/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  logo: "logo_nacional.png",
  corPrimaria: "#5c8bb9",
  isIndicadores: false,
  isSala: false,
  isAT: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  //DEV
  { tag: "dev.cidade", uf: "SC" },
  {
    tag: "dev.selo",
    banco: "selo-dev",
    uf: "AL",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "dev.agentesterritoriais",
    banco: "at-dev",
    uf: "RJ",
    isAT: true,
    logo: "logo_at_branca.png",
    corPrimaria: "#93CE98",
  },
  //HLG
  { tag: "hlg.cidade", uf: "RJ" },
  {
    tag: "hlg.selo",
    banco: "selo-hlg",
    uf: "RJ",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "hlg.agentesterritoriais",
    banco: "at-hlg",
    uf: "RJ",
    isAT: true,
    logo: "logo_at_branca.png",
    corPrimaria: "#93CE98",
  },
  {
    tag: "sp-hlg",
    uf: "SP",
    logo: "logo_consorcio_branco.png",
    isIndicadores: true,
    banco: "ce-sp-hlg",
  },
  { tag: "sc-hlg", uf: "SC", banco: "ce-sc-hlg" },
  { tag: "ms-hlg", uf: "MS", banco: "ce-ms-hlg" },
  { tag: "es-hlg", uf: "ES", banco: "ce-es-hlg" },
  { tag: "al-hlg", uf: "AL", banco: "ce-al-hlg" },
  { tag: "ma-hlg", uf: "MA", banco: "ce-ma-hlg" },
  { tag: "ap-hlg", uf: "AP", banco: "ce-ap-hlg" },
  { tag: "ba-hlg", uf: "BA", banco: "ce-ba-hlg" },
  { tag: "rj-hlg", uf: "RJ", banco: "ce-rj-hlg" },
  { tag: "ac-hlg", uf: "AC", banco: "ce-ac-hlg" },
  { tag: "am-hlg", uf: "AM", banco: "ce-am-hlg" },
  { tag: "ce-hlg", uf: "CE", banco: "ce-ce-hlg" },
  { tag: "go-hlg", uf: "GO", banco: "ce-go-hlg" },
  { tag: "mt-hlg", uf: "MT", banco: "ce-mt-hlg" },
  { tag: "mg-hlg", uf: "MG", banco: "ce-mg-hlg" },
  { tag: "pa-hlg", uf: "PA", banco: "ce-pa-hlg" },
  { tag: "pb-hlg", uf: "PB", banco: "ce-pb-hlg" },
  { tag: "pr-hlg", uf: "PR", banco: "ce-pr-hlg" },
  { tag: "pe-hlg", uf: "PE", banco: "ce-pe-hlg" },
  { tag: "pi-hlg", uf: "PI", banco: "ce-pi-hlg" },
  { tag: "rn-hlg", uf: "RN", banco: "ce-rn-hlg" },
  { tag: "rs-hlg", uf: "RS", banco: "ce-rs-hlg" },
  { tag: "ro-hlg", uf: "RO", banco: "ce-ro-hlg" },
  { tag: "rr-hlg", uf: "RR", banco: "ce-rr-hlg" },
  { tag: "se-hlg", uf: "SE", banco: "ce-se-hlg" },
  { tag: "to-hlg", uf: "TO", banco: "ce-to-hlg" },
  { tag: "df-hlg", uf: "DF", banco: "ce-df-hlg" },

  // PROD
  { tag: "ac.", banco: "ac", uf: "AC" },
  { tag: "ms.", banco: "ms", uf: "MS" },
  { tag: "al.", banco: "al", uf: "AL" },
  { tag: "ma.", banco: "ma", uf: "MA" },
  { tag: "rj.", banco: "rj", uf: "RJ" },
  { tag: "sp.", banco: "sp", uf: "SP", logo: "logo_consorcio_branco.png" },
  { tag: "es.", banco: "es", uf: "ES" },
  { tag: "ba.cidade", banco: "ba", uf: "BA" },
  { tag: "sc.", banco: "sc", uf: "SC" },
  { tag: "ap.", banco: "ap", uf: "AP" },
  { tag: "am.", banco: "am", uf: "AM" },
  { tag: "ce.", banco: "ce", uf: "CE" },
  { tag: "go.", banco: "go", uf: "GO" },
  { tag: "mt.", banco: "mt", uf: "MT" },
  { tag: "pa.", banco: "pa", uf: "PA" },
  { tag: "pb.", banco: "pb", uf: "PB" },
  { tag: "pr.", banco: "pr", uf: "PR" },
  { tag: "pe.", banco: "pe", uf: "PE" },
  { tag: "pi.", banco: "pi", uf: "PI" },
  { tag: "rn.", banco: "rn", uf: "RN" },
  { tag: "mg.", banco: "mg", uf: "MG" },
  { tag: "rs.", banco: "rs", uf: "RS" },
  { tag: "ro.", banco: "ro", uf: "RO" },
  { tag: "rr.", banco: "rr", uf: "RR" },
  { tag: "se.", banco: "se", uf: "SE" },
  { tag: "to.", banco: "to", uf: "TO" },
  { tag: "df.", banco: "df", uf: "DF" },
  { tag: "na.", banco: "na", uf: "NA" },
  {
    tag: "sc-2022",
    env: process.env.VUE_APP_BASE_API_SC_2022,
    banco: "cidade-empreendedora-sc-2022",
    uf: "SC",
    logo: "logo_consorcio_branco.png",
  },
  {
    tag: "indicadores-sp",
    banco: "cidade-empreendedora-sp-indicadores",
    uf: "SP",
    logo: "logo_consorcio_branco.png",
    isIndicadores: true,
  },
  {
    tag: "indicadores.consorcioempreendedor",
    ufEmail: "indicadores.consorcioempreendedor",
    banco: "sp",
    uf: "SP",
    logo: "logo_consorcio_branco.png",
  },
  // selo
  {
    tag: "rj.selo",
    banco: "selo-sala-rj",
    uf: "RJ",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "al.selo",
    banco: "selo-sala-al",
    uf: "AL",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ac.selo",
    banco: "selo-sala-ac",
    uf: "AC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ms.selo",
    banco: "selo-sala-ms",
    uf: "MS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ma.selo",
    banco: "selo-sala-ma",
    uf: "MA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sp.selo",
    banco: "selo-sala-sp",
    uf: "SP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "es.selo",
    banco: "selo-sala-es",
    uf: "ES",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ba.selo",
    banco: "selo-sala-ba",
    uf: "BA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sc.selo",
    banco: "selo-sala-sc",
    uf: "SC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ap.selo",
    banco: "selo-sala-ap",
    uf: "AP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "am.selo",
    banco: "selo-sala-am",
    uf: "AM",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ce.selo",
    banco: "selo-sala-ce",
    uf: "CE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "go.selo",
    banco: "selo-sala-go",
    uf: "GO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mt.selo",
    banco: "selo-sala-mt",
    uf: "MT",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pa.selo",
    banco: "selo-sala-pa",
    uf: "PA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pb.selo",
    banco: "selo-sala-pb",
    uf: "PB",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pr.selo",
    banco: "selo-sala-pr",
    uf: "PR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pe.selo",
    banco: "selo-sala-pe",
    uf: "PE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pi.selo",
    banco: "selo-sala-pi",
    uf: "PI",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rn.selo",
    banco: "selo-sala-rn",
    uf: "RN",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg.selo",
    banco: "selo-sala-mg",
    uf: "MG",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rs.selo",
    banco: "selo-sala-rs",
    uf: "RS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ro.selo",
    banco: "selo-sala-ro",
    uf: "RO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rr.selo",
    banco: "selo-sala-rr",
    uf: "RR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "se.selo",
    banco: "selo-sala-se",
    uf: "SE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "to.selo",
    banco: "selo-sala-to",
    uf: "TO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "df.selo",
    banco: "selo-sala-df",
    uf: "DF",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg-parceiros.selo",
    banco: "selo-sala-mg-parceiros",
    uf: "MG",
    isSala: true,
    isParceiro: true,
    corPrimaria: "#DAA520",
  },
  //sistema selo
  {
    tag: "rj.sistemaselo",
    banco: "selo-sala-rj",
    uf: "RJ",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "al.sistemaselo",
    banco: "selo-sala-al",
    uf: "AL",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ac.sistemaselo",
    banco: "selo-sala-ac",
    uf: "AC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ms.sistemaselo",
    banco: "selo-sala-ms",
    uf: "MS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ma.sistemaselo",
    banco: "selo-sala-ma",
    uf: "MA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sp.sistemaselo",
    banco: "selo-sala-sp",
    uf: "SP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "es.sistemaselo",
    banco: "selo-sala-es",
    uf: "ES",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ba.sistemaselo",
    banco: "selo-sala-ba",
    uf: "BA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sc.sistemaselo",
    banco: "selo-sala-sc",
    uf: "SC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ap.sistemaselo",
    banco: "selo-sala-ap",
    uf: "AP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "am.sistemaselo",
    banco: "selo-sala-am",
    uf: "AM",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ce.sistemaselo",
    banco: "selo-sala-ce",
    uf: "CE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "go.sistemaselo",
    banco: "selo-sala-go",
    uf: "GO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mt.sistemaselo",
    banco: "selo-sala-mt",
    uf: "MT",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pa.sistemaselo",
    banco: "selo-sala-pa",
    uf: "PA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pb.sistemaselo",
    banco: "selo-sala-pb",
    uf: "PB",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pr.sistemaselo",
    banco: "selo-sala-pr",
    uf: "PR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pe.sistemaselo",
    banco: "selo-sala-pe",
    uf: "PE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pi.sistemaselo",
    banco: "selo-sala-pi",
    uf: "PI",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rn.sistemaselo",
    banco: "selo-sala-rn",
    uf: "RN",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg.sistemaselo",
    banco: "selo-sala-mg",
    uf: "MG",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rs.sistemaselo",
    banco: "selo-sala-rs",
    uf: "RS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ro.sistemaselo",
    banco: "selo-sala-ro",
    uf: "RO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rr.sistemaselo",
    banco: "selo-sala-rr",
    uf: "RR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "se.sistemaselo",
    banco: "selo-sala-se",
    uf: "SE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "to.sistemaselo",
    banco: "selo-sala-to",
    uf: "TO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "df.sistemaselo",
    banco: "selo-sala-df",
    uf: "DF",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg-parceiros.sistemaselo",
    banco: "selo-sala-mg-parceiros",
    uf: "MG",
    isSala: true,
    isParceiro: true,
    corPrimaria: "#DAA520",
  },
  // agentes territoriais
  {
    tag: "rj.agentesterritoriais",
    banco: "agentes-territoriais-rj",
    uf: "RJ",
    isAT: true,
    logo: "logo_at_branca.png",
    corPrimaria: "#93CE98",
  },
  //#region selo 2023
  {
    tag: "rj-2023.selo",
    banco: "selo-2023-rj",
    uf: "RJ",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "al-2023.selo",
    banco: "selo-2023-al",
    uf: "AL",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ac-2023.selo",
    banco: "selo-2023-ac",
    uf: "AC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ms-2023.selo",
    banco: "selo-2023-ms",
    uf: "MS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ma-2023.selo",
    banco: "selo-2023-ma",
    uf: "MA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sp-2023.selo",
    banco: "selo-2023-sp",
    uf: "SP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "es-2023.selo",
    banco: "selo-2023-es",
    uf: "ES",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ba-2023.selo",
    banco: "selo-2023-ba",
    uf: "BA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sc-2023.selo",
    banco: "selo-2023-sc",
    uf: "SC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ap-2023.selo",
    banco: "selo-2023-ap",
    uf: "AP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "am-2023.selo",
    banco: "selo-2023-am",
    uf: "AM",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ce-2023.selo",
    banco: "selo-2023-ce",
    uf: "CE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "go-2023.selo",
    banco: "selo-2023-go",
    uf: "GO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mt-2023.selo",
    banco: "selo-2023-mt",
    uf: "MT",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pa-2023.selo",
    banco: "selo-2023-pa",
    uf: "PA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pb-2023.selo",
    banco: "selo-2023-pb",
    uf: "PB",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pr-2023.selo",
    banco: "selo-2023-pr",
    uf: "PR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pe-2023.selo",
    banco: "selo-2023-pe",
    uf: "PE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pi-2023.selo",
    banco: "selo-2023-pi",
    uf: "PI",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rn-2023.selo",
    banco: "selo-2023-rn",
    uf: "RN",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg-2023.selo",
    banco: "selo-2023-mg",
    uf: "MG",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rs-2023.selo",
    banco: "selo-2023-rs",
    uf: "RS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ro-2023.selo",
    banco: "selo-2023-ro",
    uf: "RO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rr-2023.selo",
    banco: "selo-2023-rr",
    uf: "RR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "se-2023.selo",
    banco: "selo-2023-se",
    uf: "SE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "to-2023.selo",
    banco: "selo-2023-to",
    uf: "TO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "df-2023.selo",
    banco: "selo-2023-df",
    uf: "DF",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg-parceiros-2023.selo",
    banco: "selo-2023-mg-parceiros",
    uf: "MG",
    isParceiro: true,

    corPrimaria: "#DAA520",
  },

  //#region selo 2023
  {
    tag: "rj-2023.sistema",
    banco: "selo-2023-rj",
    uf: "RJ",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "al-2023.sistema",
    banco: "selo-2023-al",
    uf: "AL",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ac-2023.sistema",
    banco: "selo-2023-ac",
    uf: "AC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ms-2023.sistema",
    banco: "selo-2023-ms",
    uf: "MS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ma-2023.sistema",
    banco: "selo-2023-ma",
    uf: "MA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sp-2023.sistema",
    banco: "selo-2023-sp",
    uf: "SP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "es-2023.sistema",
    banco: "selo-2023-es",
    uf: "ES",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ba-2023.sistema",
    banco: "selo-2023-ba",
    uf: "BA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "sc-2023.sistema",
    banco: "selo-2023-sc",
    uf: "SC",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ap-2023.sistema",
    banco: "selo-2023-ap",
    uf: "AP",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "am-2023.sistema",
    banco: "selo-2023-am",
    uf: "AM",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ce-2023.sistema",
    banco: "selo-2023-ce",
    uf: "CE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "go-2023.sistema",
    banco: "selo-2023-go",
    uf: "GO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mt-2023.sistema",
    banco: "selo-2023-mt",
    uf: "MT",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pa-2023.sistema",
    banco: "selo-2023-pa",
    uf: "PA",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pb-2023.sistema",
    banco: "selo-2023-pb",
    uf: "PB",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pr-2023.sistema",
    banco: "selo-2023-pr",
    uf: "PR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pe-2023.sistema",
    banco: "selo-2023-pe",
    uf: "PE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "pi-2023.sistema",
    banco: "selo-2023-pi",
    uf: "PI",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rn-2023.sistema",
    banco: "selo-2023-rn",
    uf: "RN",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "mg-2023.sistema",
    banco: "selo-2023-mg",
    uf: "MG",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rs-2023.sistema",
    banco: "selo-2023-rs",
    uf: "RS",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "ro-2023.sistema",
    banco: "selo-2023-ro",
    uf: "RO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "rr-2023.sistema",
    banco: "selo-2023-rr",
    uf: "RR",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "se-2023.sistema",
    banco: "selo-2023-se",
    uf: "SE",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "to-2023.sistema",
    banco: "selo-2023-to",
    uf: "TO",
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "df-2023.sistema",
    banco: "selo-2023-df",
    uf: "DF",
    isSala: true,
    corPrimaria: "#DAA520",
  },

  {
    tag: "mg-parceiros-2023.sistema",
    banco: "selo-2023-mg-parceiros",
    uf: "MG",
        isParceiro: true,
    isSala: true,
    corPrimaria: "#DAA520",
  },
  {
    tag: "localhost",
    uf: "AL",
    banco: "selo-2023-al",
    isSala: true,
    corPrimaria: "#DAA520",
  },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

let atual;
let hrf = window.location.href;
const ceDevBanco = "ce-dev";
const ceHlgBanco = "ce-hlg";

ufsDefinitions.forEach((item) => {
  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (item.tag.indexOf("dev") !== -1) {
      if (!item.banco) {
        item.banco = ceDevBanco;
      }
      item.env = process.env.VUE_APP_BASE_API_DEV;
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      if (!item.banco) {
        item.banco = ceHlgBanco;
      }
      item.env = process.env.VUE_APP_BASE_API_HLG;
      // urls com localhost no nome
    } else if (item.tag.indexOf("localhost") !== -1) {
      if (!item.banco) {
        item.banco = ceDevBanco;
      }
      item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      if (!item.env) {
        item.env = process.env.VUE_APP_BASE_API_PROD;
      }
    }
    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      let indexOfArroba = str.indexOf("@", 0);
      let indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      let names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (a > b) return +1;
  if (a < b) return -1;
  return 0;
};
